<h1 class="motif-h4-default-regular">{{ 'login.title' | translate }}</h1>
<button motifButton color="primary" (click)="login()">
  {{ 'login.cta' | translate }}
</button>
